import {
  ChangeDetectorRef,
  Component, EventEmitter, Input, OnInit, Output
} from '@angular/core';
import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { Post } from "../../../app/app.interfaces";
import { ApiService } from "../../../services/api.service";
import { UserGroupService } from "../../../services/user-group.service";
import { IonicHelper } from "../../../helpers/ionic.helper";
import { FormHelper } from "../../../helpers/form.helper";
import { CategoryService } from '../../../services/category.service';
import { TagService } from '../../../services/tag.service';
import { ButtonStyle } from '../../upload/file-upload';

@Component({
  selector: 'post-edit',
  templateUrl: 'post-edit.html'
})

export class PostEdit implements OnInit {

  form: FormGroup;
  showGroupsDropdown: boolean = false;
  buttonStyleButton = ButtonStyle.Button;

  @Input() post: Post;
  @Output() postChange: EventEmitter<Post|void> = new EventEmitter<Post|void>();

  constructor(private formHelper: FormHelper,
              public userGroupService: UserGroupService,
              public categoryService: CategoryService,
              public tagService: TagService,
              private apiService: ApiService,
              public ionic: IonicHelper,
              private changeDetector: ChangeDetectorRef
              ) {


  }
  

  ngOnInit(): void {
    
    if (this.post) {
      if (!this.post.userHasModeratingAccess) {
        throw new Error('User does not have moderating access to post ' + this.post.id);
      }

      this.formHelper.buildPostForm(this.post).then((form) => {
        this.form = form;
      });
      	
    }
  }


  cancel(){
    this.postChange.emit();
  }
  

  submitForm(): void {

    this.ionic.toggleLoader(true);
    
    if(this.form.valid) {
            
      //new way:
      let changedPost = FormHelper.updateObjectWithFormValues(this.post, this.form, {
        userGroups: this.userGroupService.userGroups,
        categories: this.categoryService.categories
      });
      
      this.apiService.updateResource(changedPost).then((post: Post) => {
        this.ionic.toggleLoader(false); 
	      this.ionic.toast('POST.UPDATED');
        this.post = post;
        this.postChange.emit(post);

      }).catch((err)=>{
        console.error(err);
        this.ionic.alert('GLOBAL.GENERAL_ERROR');
        this.ionic.toggleLoader(false); 
      });
    }
    else {    	
      this.ionic.toggleLoader(false);   
      this.ionic.invalidFieldsAlert(
    	'POST_CREATE.ERROR',
    		'POST_CREATE.TRY_AGAIN',
    		'POST_CREATE.ERRORS',
    		FormHelper.getInvalidFormControls(this.form.controls)    		
    	);
    }

  }

  toggleGroupsDropdown(show: boolean = null) {
    if (show !== null) this.showGroupsDropdown = show;
    else this.showGroupsDropdown = !this.showGroupsDropdown;
     
  	this.changeDetector.detectChanges();
  }

	addAttachmentField(): void {    
    let newFormControl = new FormControl(null);
    let attachmentControls = this.form.get('attachments') as FormArray;
    attachmentControls.push(newFormControl);
  }
	
  attachmentUploadError(ev){
    this.ionic.alert('POST_CREATE.ADD_ATTACHMENT_ERROR');
  }
  
	removeAttachmentField(i): void {
    (this.form.get('attachments') as any).removeAt(i);
  }

}




// WEBPACK FOOTER //
// ./src/partials/post/post-edit/post-edit.ts